export const UPDATE_ORGANIZATION_CLIENTS = 'clients/UPDATE_ORGANIZATION_CLIENTS'
export const UPDATE_ORGANIZATION_CURRENT_CLIENT = 'clients/UPDATE_ORGANIZATION_CURRENT_CLIENT'
export const UPDATE_CLIENTS_LIST = 'clients/UPDATE_CLIENTS_LIST'
export const UPDATE_TOTAL_AMOUNT = 'clients/UPDATE_TOTAL_AMOUNT'
export const IS_LOADING = 'clients/IS_LOADING'
